<template>
  <div class="w-full h-full flex flex-col">
    <Header />

    <div class="w-full flex-1-0-auto flex flex-col">
      <a id="focusResetAnchor" tabindex="-1" class="hidden" />
      <RouterView :key="$route.fullPath" />
    </div>

    <LostConnectionPopup />
    <SessionPopup />

    <Footer />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'

import Header from '~app/psp/swiss/header.vue'
import Footer from '~app/psp/swiss/footer.vue'
import LostConnectionPopup from '~app/psp/swiss/lost-connection-popup.vue'
import SessionPopup from '~app/psp/swiss/session-popup.vue'

export default Vue.extend({
  components: {
    Header,
    Footer,
    LostConnectionPopup,
    SessionPopup,
  },
})
</script>
